// extracted by mini-css-extract-plugin
export default {"decorations":"AvailableDecorations_decorations__HGnbP","decorations-appear":"AvailableDecorations_decorations-appear__z713W"};